import React from 'react';
import PropTypes from 'prop-types';
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	makeStyles,
	useTheme,
	useMediaQuery,
	Typography
} from '@material-ui/core';

import AvatarPin from "../assets/avatar-pin.png";
import Constants from "../utils/Constants";
import TwitterRedaction from "./TwitterRedaction";

const styles = makeStyles(theme => ({
	container: {
		height: '40vh',
		width: '100%',
		position: 'relative'
	},

	details: {
		padding: theme.spacing(3),
	},

	secondary: {
		color: theme.palette.text.secondary
	},

	geoFenceIcon: {
		fontSize: "1.1em",
		marginRight: theme.spacing(.75)
	}
}));

function PostMap(props) {
	const theme = useTheme();
	const isMD = useMediaQuery(theme.breakpoints.up("md"));

	const getGeoFenceText = association => {
		let text = "within geo-fence",
			distance = association["nearest_distance"],
			location = association["nearest_location"];

		if (distance !== 0.0 && location !== "") {
			let numFormatter = new Intl.NumberFormat();
			text = `${numFormatter.format(distance)} mi from ${location}`;
		}

		return text;
	};

	let classes = styles(),
		{ google, association, twitterRedacted, history, category} = props,
		content = association ? association.content : null,
		center = {lat: content.latitude, lng: content.longitude},
		zoom = 11;

	return twitterRedacted && twitterRedacted === Constants.ACTIVITY.TWITTER_REDACTION.SCRUB_GEO ? (
		<TwitterRedaction
			twitterRedacted={twitterRedacted}
			history={history}
			isAlert={category === Constants.ACTIVITY.CATEGORIES.ALERTS.ID} />
	) : (
		<div>
			{/* Important! Always set the map container height explicitly */}
			<div className={classes.container}>
				<Map google={google}
					zoom={zoom}
					initialCenter={center} >
					<Marker
						name={'Your position'}
						position={center}
						icon={{
							url: AvatarPin
						}} />
				</Map>
			</div>
			<div className={classes.details}>
				<Typography>{isMD ? "Lat/Long" : "Latitude/Longitude"} of Post Location</Typography>
				<Typography className={classes.secondary}>{content.latitude}{', '}{content.longitude}</Typography>
				<Typography className={classes.secondary}>
					<FontAwesomeIcon
						title="map marker"
						icon={["fal", "map-marker-alt"]}
						className={classes.geoFenceIcon} /><i>{getGeoFenceText(association)}</i>
				</Typography>
			</div>
		</div>
	);
}

PostMap.propTypes = {
	key: PropTypes.number,
	association: PropTypes.object,
	twitterRedacted: PropTypes.string,
	google: PropTypes.object,
	history: PropTypes.object.isRequired,
	category: PropTypes.number
};

export default GoogleApiWrapper(
	{apiKey: process.env.REACT_APP_MAPS_KEY}
)(PostMap);
